import { AxiosResponse, CancelToken } from 'axios';
import { API_URL } from '../config/config';
import BaseRequest from '../http-requests/BaseRequest';
import { CommonListItemType } from '../types/general';
import { ThesaurusSearchItemDatatype } from '../types/ThesaurusSearch';
import {
    ThesaurusSearchItemType
} from '../../modules/consulta/components/SearchBar/thesaurus/types/ThesaurusSearchItemType';

const ServiceBaseUrl = `${API_URL}/thesaurus`;

export const getSearchOptions = async(cancelToken?: CancelToken): Promise<AxiosResponse<CommonListItemType[]>> => {
    return BaseRequest.axiosInst.get(`${ServiceBaseUrl}/get-search-options`, {
        headers: BaseRequest.publicHeaders,
        cancelToken,
    });
}

export const getThesaurusSearch = async(searchTerm: string, searchOption: string, cancelToken?: CancelToken): Promise<AxiosResponse<ThesaurusSearchItemDatatype[]>> => {
    return BaseRequest.axiosInst.get(`${ServiceBaseUrl}/get-thesaurus-search`, {
        headers: BaseRequest.publicHeaders,
        cancelToken,
        params: {
            searchTerm,
            searchOption,
        }
    });
}

export const getChildren = async(codAutoridade: string, searchOption: string, cancelToken?: CancelToken): Promise<AxiosResponse<ThesaurusSearchItemType[]>> => {
    return BaseRequest.axiosInst.get(`${ServiceBaseUrl}/get-thesaurus-children`, {
        headers: BaseRequest.publicHeaders,
        cancelToken,
        params: {
            codAutoridade,
            searchOption,
        }
    });
}
